import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-174344c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "timenow"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "header-title"
};
const _hoisted_5 = {
  style: {
    "overflow": "hidden"
  }
};
const _hoisted_6 = {
  class: "header-memo"
};
const _hoisted_7 = {
  class: "header-memo"
};
const _hoisted_8 = {
  class: "header-memo"
};
const _hoisted_9 = {
  key: 0,
  class: "activedetail"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-title"
}, "今日活跃", -1));
const _hoisted_11 = {
  key: 0,
  class: "activeBoxLHDG"
};
const _hoisted_12 = {
  class: "num-item"
};
const _hoisted_13 = {
  class: "num-item-cnt",
  style: {
    "color": "#faad14"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "num-item-text"
}, "已活跃", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_16 = {
  class: "num-item"
};
const _hoisted_17 = {
  class: "num-item-cnt",
  style: {
    "color": "#52c41a"
  }
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "num-item-text"
}, "活跃合格", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_20 = {
  class: "num-item"
};
const _hoisted_21 = {
  class: "num-item-cnt",
  style: {
    "color": "#1890ff"
  }
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "num-item-text"
}, "活跃合格率", -1));
const _hoisted_23 = {
  key: 1,
  class: "activeBox"
};
const _hoisted_24 = {
  class: "left"
};
const _hoisted_25 = {
  class: "num-item"
};
const _hoisted_26 = {
  class: "num-item-cnt"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "num-item-text"
}, "今日应活跃", -1));
const _hoisted_28 = {
  class: "num-item"
};
const _hoisted_29 = {
  class: "num-item-cnt",
  style: {
    "color": "#52c41a"
  }
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "num-item-text"
}, "已活跃", -1));
const _hoisted_31 = {
  class: "num-item"
};
const _hoisted_32 = {
  class: "num-item-cnt",
  style: {
    "color": "#1890ff"
  }
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "num-item-text"
}, "未活跃", -1));
const _hoisted_34 = {
  class: "right"
};
const _hoisted_35 = {
  class: "activationdetail"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-title"
}, "激活情况", -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-title1"
}, "（截止目前计划领取情况）", -1));
const _hoisted_38 = {
  class: "activation-box-head"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activation-box-head-title"
}, "终端计划总数", -1));
const _hoisted_40 = {
  class: "activation-box-head-cnt"
};
const _hoisted_41 = {
  class: "activation-box-content"
};
const _hoisted_42 = {
  class: "activation-box-content-date"
};
const _hoisted_43 = {
  class: "activation-box-content-cnt"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activation-box-content-text"
}, "已激活", -1));
const _hoisted_45 = {
  style: {
    "margin": "0 0.02rem"
  },
  class: "activation-box-content-date"
};
const _hoisted_46 = {
  class: "activation-box-content-cnt"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activation-box-content-text"
}, "未激活", -1));
const _hoisted_48 = {
  class: "activation-box-content-date"
};
const _hoisted_49 = {
  class: "activation-box-content-cnt"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activation-box-content-text"
}, "激活率", -1));
const _hoisted_51 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activation-foot"
}, "以上统计结果不包含已取消计划", -1));
const _hoisted_53 = {
  class: "activedetail"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-title"
}, "活跃概览", -1));
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-title1"
}, "（计划内触点每日任务获取情况）", -1));
const _hoisted_56 = {
  class: "active-content-box"
};
const _hoisted_57 = {
  class: "active-content-box-cnt"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "active-content-box-text"
}, "累计活跃获取", -1));
const _hoisted_59 = {
  class: "active-content-box"
};
const _hoisted_60 = {
  class: "active-content-box-cnt"
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "active-content-box-text"
}, "累计活跃合格", -1));
const _hoisted_62 = {
  class: "activation-box-head"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activation-box-head-title"
}, "计划总活跃次数", -1));
const _hoisted_64 = {
  class: "activation-box-head-cnt"
};
const _hoisted_65 = {
  class: "activation-box-content"
};
const _hoisted_66 = {
  class: "activation-box-content-date"
};
const _hoisted_67 = {
  class: "activation-box-content-cnt"
};
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activation-box-content-text"
}, "活跃获取", -1));
const _hoisted_69 = {
  style: {
    "margin": "0 0.02rem"
  },
  class: "activation-box-content-date"
};
const _hoisted_70 = {
  class: "activation-box-content-cnt"
};
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activation-box-content-text"
}, "活跃合格", -1));
const _hoisted_72 = {
  class: "activation-box-content-date"
};
const _hoisted_73 = {
  class: "activation-box-content-cnt"
};
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "activation-box-content-text"
}, "活跃合格率", -1));
const _hoisted_75 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "active-foot"
}, "以上统计结果不包含已取消计划", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _$data$activedate, _$data$activedate2, _$data$activedate3, _$data$activedate4, _$data$activedate5, _$data$activedate6, _$data$activedate7, _$data$activedate8, _$data$activedate9, _$data$activedate10, _$data$activedate11, _$data$activedate12;
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_activation_pie_chart = _resolveComponent("activation-pie-chart");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_activation_stacked_chart1 = _resolveComponent("activation-stacked-chart1");
  const _component_activation_stacked_chart = _resolveComponent("activation-stacked-chart");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, "当前数据更新时间:" + _toDisplayString($data.projectDate.updateTime), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($data.projectDate.projectName) + "（" + _toDisplayString($data.projectDate.month) + "）", 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, "所属月份：" + _toDisplayString($data.monthdata) + "月", 1), _createElementVNode("div", _hoisted_7, "计划执行日期：" + _toDisplayString($data.projectDate.startDate) + " 至 " + _toDisplayString($data.projectDate.endDate), 1), _createElementVNode("div", _hoisted_8, [_createTextVNode(" 计划终端数量：" + _toDisplayString($data.projectDate.terminalNum) + " 家 ", 1), _createElementVNode("span", {
    style: {
      "color": "#5a80b0",
      "margin-left": "4px"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goTerminal && $options.goTerminal(...args))
  }, "[ 查看详情 ]")])])]), $data.datetype === 'now' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_van_cell, {
    "is-link": "",
    value: "详情",
    style: {
      "padding-bottom": "0.2rem"
    },
    onClick: _cache[1] || (_cache[1] = $event => $options.goActive('日'))
  }, {
    title: _withCtx(() => [_hoisted_10]),
    _: 1
  }), ((_$data$activedate = $data.activedate) === null || _$data$activedate === void 0 || (_$data$activedate = _$data$activedate.attTodayCO) === null || _$data$activedate === void 0 ? void 0 : _$data$activedate.projectCategory) === 'LHDG' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(((_$data$activedate2 = $data.activedate) === null || _$data$activedate2 === void 0 || (_$data$activedate2 = _$data$activedate2.attTodayCO) === null || _$data$activedate2 === void 0 ? void 0 : _$data$activedate2.attDayLhdg) || 0), 1), _hoisted_14]), _hoisted_15, _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(((_$data$activedate3 = $data.activedate) === null || _$data$activedate3 === void 0 || (_$data$activedate3 = _$data$activedate3.attTodayCO) === null || _$data$activedate3 === void 0 ? void 0 : _$data$activedate3.attQua) || 0), 1), _hoisted_18]), _hoisted_19, _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(((_$data$activedate4 = $data.activedate) === null || _$data$activedate4 === void 0 || (_$data$activedate4 = _$data$activedate4.attTodayCO) === null || _$data$activedate4 === void 0 ? void 0 : _$data$activedate4.attPassRate) || 0) + "%", 1), _hoisted_22])])) : _createCommentVNode("", true), ((_$data$activedate5 = $data.activedate) === null || _$data$activedate5 === void 0 || (_$data$activedate5 = _$data$activedate5.attTodayCO) === null || _$data$activedate5 === void 0 ? void 0 : _$data$activedate5.projectCategory) === 'DP' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(((_$data$activedate6 = $data.activedate) === null || _$data$activedate6 === void 0 || (_$data$activedate6 = _$data$activedate6.attTodayCO) === null || _$data$activedate6 === void 0 ? void 0 : _$data$activedate6.attExpect) || 0), 1), _hoisted_27]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(((_$data$activedate7 = $data.activedate) === null || _$data$activedate7 === void 0 || (_$data$activedate7 = _$data$activedate7.attTodayCO) === null || _$data$activedate7 === void 0 ? void 0 : _$data$activedate7.attDayDP) || 0), 1), _hoisted_30]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(((_$data$activedate8 = $data.activedate) === null || _$data$activedate8 === void 0 || (_$data$activedate8 = _$data$activedate8.attTodayCO) === null || _$data$activedate8 === void 0 ? void 0 : _$data$activedate8.attNot) || 0), 1), _hoisted_33])]), _createElementVNode("div", _hoisted_34, [(_$data$activedate9 = $data.activedate) !== null && _$data$activedate9 !== void 0 && (_$data$activedate9 = _$data$activedate9.attTodayCO) !== null && _$data$activedate9 !== void 0 && _$data$activedate9.attDayDP || (_$data$activedate10 = $data.activedate) !== null && _$data$activedate10 !== void 0 && (_$data$activedate10 = _$data$activedate10.attTodayCO) !== null && _$data$activedate10 !== void 0 && _$data$activedate10.attNot ? (_openBlock(), _createBlock(_component_activation_pie_chart, {
    key: 0,
    data: [{
      name: '已活跃',
      num: ((_$data$activedate11 = $data.activedate) === null || _$data$activedate11 === void 0 || (_$data$activedate11 = _$data$activedate11.attTodayCO) === null || _$data$activedate11 === void 0 ? void 0 : _$data$activedate11.attDayDP) || 0,
      a: '1'
    }, {
      name: '未活跃',
      num: ((_$data$activedate12 = $data.activedate) === null || _$data$activedate12 === void 0 || (_$data$activedate12 = _$data$activedate12.attTodayCO) === null || _$data$activedate12 === void 0 ? void 0 : _$data$activedate12.attNot) || 0,
      a: '1'
    }],
    id: "pieChart",
    ref: "pieChart"
  }, null, 8, ["data"])) : (_openBlock(), _createBlock(_component_van_empty, {
    key: 1,
    description: "暂无数据",
    style: {
      "padding": "0"
    }
  }))])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_35, [_createVNode(_component_van_cell, {
    "is-link": "",
    value: "详情",
    style: {
      "padding-bottom": "0.2rem"
    },
    onClick: $options.goActivation
  }, {
    title: _withCtx(() => [_hoisted_36, _hoisted_37]),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("div", {
    class: "activation-box",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goActivation && $options.goActivation(...args))
  }, [_createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("div", _hoisted_40, _toDisplayString($data.activationdate.terminalPlanSumCount), 1)]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, _toDisplayString($data.activationdate.activeTerminalPlanCount), 1), _hoisted_44]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, _toDisplayString($data.activationdate.noActiveTerminalPlanCount), 1), _hoisted_47]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, _toDisplayString($data.activationdate.activationRate), 1), _hoisted_50])])]), _createElementVNode("div", _hoisted_51, [_createVNode(_component_activation_stacked_chart1, {
    data: $data.chartData1,
    id: "chart1",
    ref: "chart1"
  }, null, 8, ["data"])]), _hoisted_52]), _createElementVNode("div", _hoisted_53, [_createVNode(_component_van_cell, {
    "is-link": "",
    value: "详情",
    style: {
      "padding-bottom": "0.2rem"
    },
    onClick: _cache[3] || (_cache[3] = $event => $options.goActive())
  }, {
    title: _withCtx(() => [_hoisted_54, _hoisted_55]),
    _: 1
  }), $data.datetype === 'now' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "active-content",
    onClick: _cache[4] || (_cache[4] = $event => $options.goActive())
  }, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, _toDisplayString($data.activedate.attSum), 1), _hoisted_58]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, _toDisplayString($data.activedate.attPassSum), 1), _hoisted_61])])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "activation-box",
    onClick: _cache[5] || (_cache[5] = $event => $options.goActive())
  }, [_createElementVNode("div", _hoisted_62, [_hoisted_63, _createElementVNode("div", _hoisted_64, _toDisplayString($data.activedate.attMonth), 1)]), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, _toDisplayString($data.activedate.attSum), 1), _hoisted_68]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, _toDisplayString($data.activedate.attPassSum), 1), _hoisted_71]), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, _toDisplayString($data.activedate.attPassRate) + "%", 1), _hoisted_74])])])), _createElementVNode("div", _hoisted_75, [_createVNode(_component_activation_stacked_chart, {
    data: $data.chartData2,
    id: "chart2",
    ref: "chart2"
  }, null, 8, ["data"])]), _hoisted_76])]);
}